import { t } from '@gem/modules/i18n';
import { isFilesReadable, isFileReadable } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { showAlert } from 'APP/Tasks/app/app';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { MessageError } from 'STORE/Messages/Message/ChatMessage/ChatMessages.types';

export const uploadMessage = async (message: ChatMessage): Promise<boolean> => {
  if (!message.payload.upload) {
    return true;
  }

  // If payload has url, skip checking readability
  if (!message.payload.url) {
    const isReadable =
      !message.payload.userFile && message.payload.payloads
        ? await isFilesReadable(message.payload) //Fix for Album, Article, Advertisement payloads
        : await isFileReadable(message.payload.userFile); // Fix for File, Image, Video payloads

    if (!isReadable) {
      message.setError(MessageError.Send);

      await showAlert(t('file_sent_alert'));

      Tasks.messaging.deleteMessages({
        groupId: message.groupId,
        messages: [message],
      });

      return false;
    }
  }

  await message.payload.upload();

  return true;
};
